import { Globe } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const btnCls = (on) =>
  `px-1.5 py-0.5 rounded text-[11px] font-bold tracking-wide transition-colors duration-150 ${
    on ? 'bg-[#F29B3D] text-white' : 'text-[#CBD5E1] hover:text-white'
  }`;

export const LangToggle = ({ className = '' }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      data-no-translate
      className={`flex items-center gap-1 rounded-lg border border-white/15 bg-white/[0.04] px-2 py-1.5 ${className}`}
    >
      <Globe className="w-3.5 h-3.5 text-[#CBD5E1] shrink-0" aria-hidden="true" />
      <button type="button" data-testid="lang-en" onClick={() => setLang('en')} className={btnCls(lang === 'en')} aria-pressed={lang === 'en'}>EN</button>
      <span className="text-white/20 text-[11px]">|</span>
      <button type="button" data-testid="lang-fr" onClick={() => setLang('fr')} className={btnCls(lang === 'fr')} aria-pressed={lang === 'fr'}>FR</button>
    </div>
  );
};

export default LangToggle;
